module.exports = __webpack_public_path__ + "static/media/Viking Woman.4ad26d44.jpg";